import styled from 'styled-components/macro';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { escapeImageUrl } from '@yme/utils/common';
export const FrameInnerStyled = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-self: flex-start;

  margin: 0 auto;

  ${ADAPTIVE.minWidth.tablet} {
    margin: initial;
  }
`;
export const DeviceFrameBg = styled.div `
  position: absolute;
  display: flex;
  height: 731px;

  background-image: ${({ bgFrame }) => `url(${bgFrame ? escapeImageUrl(bgFrame) : bgFrame})`};
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: cover;
`;
export const ImagePreview = styled.div `
  flex: 1;

  & img {
    object-fit: cover;
    background-color: ${colorCoreWhite1000};
  }
`;
